/* unplugin-vue-components disabled */import { render } from "./IndexWarnActivity.vue?vue&type=template&id=711047ab&scoped=true"
import script from "./IndexWarnActivity.vue?vue&type=script&lang=js"
export * from "./IndexWarnActivity.vue?vue&type=script&lang=js"

import "./IndexWarnActivity.vue?vue&type=style&index=0&id=711047ab&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711047ab"]])

export default __exports__